(function () {
  function getMeltableBox(form) {
    if (!form) return null;
    var productWrapper = form.closest('.product_section') || form.closest('[itemscope][itemtype*="Product"]') || document;
    return productWrapper.querySelector('[data-meltable]');
  }

  function getSelectedOption(box) {
    return box ? box.querySelector('[data-meltable-option]:checked') : null;
  }

  function getSelectedChoice(box) {
    var selected = getSelectedOption(box);
    return selected ? selected.getAttribute('data-meltable-choice') || selected.value : '';
  }

  function getSelectedVariantId(box) {
    var selected = getSelectedOption(box);
    if (!selected || getSelectedChoice(box) === 'opt_out') return '';
    return selected.value || selected.getAttribute('data-variant-id') || '';
  }

  function getCoolingVariantIds(box) {
    return [
      box.getAttribute('data-ice-pack-variant-id'),
      box.getAttribute('data-cooler-variant-id')
    ].filter(Boolean);
  }

  function showError(box, message) {
    var error = box ? box.querySelector('[data-meltable-error]') : null;
    if (!error) return;
    error.textContent = message;
    error.hidden = !message;
  }

  function getOptionForVariantId(box, variantId) {
    if (!box || !variantId) return null;
    return box.querySelector('[data-meltable-option][value="' + variantId + '"]');
  }

  function selectOptionForVariantId(box, variantId) {
    var option = getOptionForVariantId(box, variantId);
    if (!option) return false;

    option.checked = true;
    return true;
  }

  function updateOptOutState(box) {
    return getSelectedChoice(box) === 'opt_out';
  }

  function updateSelectedOptionState(box) {
    if (!box) return;

    $(box).find('.meltable__option').removeClass('meltable__option--selected');

    var selected = getSelectedOption(box);
    if (selected) {
      $(selected).closest('.meltable__option').addClass('meltable__option--selected');
    }
  }

  function storePreviousSelection(box) {
    var selected = getSelectedOption(box);

    if (box && selected) {
      box.setAttribute('data-meltable-previous-option-value', selected.value);
    }
  }

  function validateSelection(box) {
    var selected = getSelectedOption(box);

    showError(box, '');

    if (!selected) {
      showError(box, 'Please select a warm weather shipping option.');
      return false;
    }

    if (getSelectedChoice(box) !== 'opt_out' && !getSelectedVariantId(box)) {
      showError(box, 'The selected melt protection option is not configured.');
      return false;
    }

    return true;
  }

  function addCoolingItem(variantId) {
    return $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: {
        id: variantId,
        quantity: 1
      }
    });
  }

  function updateCart(updates) {
    return $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',
      data: {
        updates: updates
      }
    });
  }

  function getCart() {
    return $.getJSON('/cart.js');
  }

  function findConflictingCoolingItem(cart, coolingVariantIds, selectedVariantId) {
    var conflict = null;

    $.each(cart.items, function (_, item) {
      var variantId = String(item.variant_id);
      if ($.inArray(variantId, coolingVariantIds) === -1) return;
      if (!selectedVariantId || variantId === String(selectedVariantId)) return;

      conflict = item;
      return false;
    });

    return conflict;
  }

  function findCurrentCoolingItem(cart, coolingVariantIds) {
    var current = null;

    $.each(cart.items, function (_, item) {
      var variantId = String(item.variant_id);
      if ($.inArray(variantId, coolingVariantIds) === -1) return;

      current = item;
      return false;
    });

    return current;
  }

  function clearReplacementConfirmation(box) {
    if (!box) return;
    box.removeAttribute('data-meltable-confirmed-variant-id');
  }

  function clearOptOutConfirmation(box) {
    if (!box) return;
    box.removeAttribute('data-meltable-opt-out-confirmed');
  }

  function setReplacementConfirmation(box, variantId) {
    if (!box || !variantId) return;
    box.setAttribute('data-meltable-confirmed-variant-id', String(variantId));
  }

  function hasReplacementConfirmation(box, variantId) {
    return box && variantId && box.getAttribute('data-meltable-confirmed-variant-id') === String(variantId);
  }

  function setOptOutConfirmation(box) {
    if (!box) return;
    box.setAttribute('data-meltable-opt-out-confirmed', 'true');
  }

  function hasOptOutConfirmation(box) {
    return box && box.getAttribute('data-meltable-opt-out-confirmed') === 'true';
  }

  function closeReplacementModal(modal) {
    if (!modal) return;
    modal.classList.remove('meltable-modal--visible');
    window.setTimeout(function () {
      if (modal.parentNode) modal.parentNode.removeChild(modal);
    }, 150);
  }

  function showReplacementModal(conflict, selectedVariantId) {
    var deferred = $.Deferred();
    var modal = document.createElement('div');
    var existingModal = document.querySelector('.meltable-modal');

    if (existingModal) {
      closeReplacementModal(existingModal);
    }

    modal.className = 'meltable-modal meltable-modal--visible';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'meltable-modal-title');
    modal.innerHTML = [
      '<div class="meltable-modal__overlay" data-meltable-modal-cancel></div>',
      '<div class="meltable-modal__dialog">',
      '<button type="button" class="meltable-modal__close" data-meltable-modal-cancel aria-label="Close">&times;</button>',
      '<h3 class="meltable-modal__title" id="meltable-modal-title">Replace melt protection?</h3>',
      '<p class="meltable-modal__message">Your cart can only hold one melt protection. Proceeding will replace your previous melt protection choice with the one selected here.</p>',
      '<div class="meltable-modal__actions">',
      '<button type="button" class="meltable-modal__button meltable-modal__button--secondary" data-meltable-modal-cancel>Keep Current</button>',
      '<button type="button" class="meltable-modal__button meltable-modal__button--primary" data-meltable-modal-confirm>Replace Melt Protection</button>',
      '</div>',
      '</div>'
    ].join('');

    document.body.appendChild(modal);

    modal.querySelector('[data-meltable-modal-confirm]').focus();

    $(modal).on('click', '[data-meltable-modal-confirm]', function () {
      closeReplacementModal(modal);
      deferred.resolve({ conflict: conflict, selectedVariantId: selectedVariantId });
    });

    $(modal).on('click', '[data-meltable-modal-cancel]', function () {
      closeReplacementModal(modal);
      deferred.reject({ cancelled: true, conflict: conflict });
    });

    $(document).one('keydown.meltableModal', function (event) {
      if (event.key !== 'Escape') return;
      closeReplacementModal(modal);
      deferred.reject({ cancelled: true, conflict: conflict });
    });

    deferred.always(function () {
      $(document).off('keydown.meltableModal');
    });

    return deferred.promise();
  }

  function showOptOutModal() {
    var deferred = $.Deferred();
    var modal = document.createElement('div');
    var existingModal = document.querySelector('.meltable-modal');

    if (existingModal) {
      closeReplacementModal(existingModal);
    }

    modal.className = 'meltable-modal meltable-modal--visible';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'meltable-opt-out-modal-title');
    modal.innerHTML = [
      '<div class="meltable-modal__overlay" data-meltable-modal-cancel></div>',
      '<div class="meltable-modal__dialog">',
      '<button type="button" class="meltable-modal__close" data-meltable-modal-cancel aria-label="Close">&times;</button>',
      '<h3 class="meltable-modal__title" id="meltable-opt-out-modal-title">Proceed Without Melt Protection?</h3>',
      '<p class="meltable-modal__message">Melt protection helps reduce the risk of candy softening during warm weather shipping.</p>',
      '<label class="meltable-modal__checkbox-label">',
      '<input type="checkbox" data-meltable-opt-out-modal-checkbox>',
      '<span>I understand this order may contain heat-sensitive candy and I am choosing to ship without melt protection. I accept the risk of melting during transit and agree to the <a target="_blank" href="https://allcitycandy.com/pages/melt-protection-policy">Melt Protection Policy.</a></span>',
      '</label>',
      '<p class="meltable-modal__error" data-meltable-modal-error hidden>Please acknowledge the meltable product policy before opting out.</p>',
      '<div class="meltable-modal__actions">',
      '<button type="button" class="meltable-modal__button meltable-modal__button--secondary" data-meltable-modal-cancel>Add Melt Protection</button>',
      '<button type="button" class="meltable-modal__button meltable-modal__button--primary" data-meltable-opt-out-modal-confirm>Continue Without Protection</button>',
      '</div>',
      '</div>'
    ].join('');

    document.body.appendChild(modal);

    modal.querySelector('[data-meltable-opt-out-modal-checkbox]').focus();

    $(modal).on('click', '[data-meltable-opt-out-modal-confirm]', function () {
      var checkbox = modal.querySelector('[data-meltable-opt-out-modal-checkbox]');
      var error = modal.querySelector('[data-meltable-modal-error]');

      if (!checkbox.checked) {
        error.hidden = false;
        return;
      }

      closeReplacementModal(modal);
      deferred.resolve();
    });

    $(modal).on('click', '[data-meltable-modal-cancel]', function () {
      closeReplacementModal(modal);
      deferred.reject({ cancelled: true });
    });

    $(document).one('keydown.meltableOptOutModal', function (event) {
      if (event.key !== 'Escape') return;
      closeReplacementModal(modal);
      deferred.reject({ cancelled: true });
    });

    deferred.always(function () {
      $(document).off('keydown.meltableOptOutModal');
    });

    return deferred.promise();
  }

  function confirmOptOut(box) {
    if (getSelectedChoice(box) !== 'opt_out') {
      clearOptOutConfirmation(box);
      return $.Deferred().resolve().promise();
    }

    if (hasOptOutConfirmation(box)) {
      return $.Deferred().resolve().promise();
    }

    return showOptOutModal().then(function () {
      setOptOutConfirmation(box);
    });
  }

  function confirmCoolingReplacement(box, selectedVariantId) {
    var coolingVariantIds = getCoolingVariantIds(box);

    if (!selectedVariantId || !coolingVariantIds.length) {
      return $.Deferred().resolve().promise();
    }

    if (hasReplacementConfirmation(box, selectedVariantId)) {
      return $.Deferred().resolve().promise();
    }

    return getCart().then(function (cart) {
      var conflict = findConflictingCoolingItem(cart, coolingVariantIds, selectedVariantId);

      if (!conflict) {
        return cart;
      }

      return showReplacementModal(conflict, selectedVariantId).then(function () {
        setReplacementConfirmation(box, selectedVariantId);
        return cart;
      });
    });
  }

  function prepareSelection(box, selectedVariantId) {
    if (getSelectedChoice(box) === 'opt_out') {
      return confirmOptOut(box);
    }

    return confirmCoolingReplacement(box, selectedVariantId);
  }

  function initializeFromCart(box) {
    var coolingVariantIds = getCoolingVariantIds(box);

    if (!coolingVariantIds.length) {
      updateOptOutState(box);
      return;
    }

    getCart()
      .done(function (cart) {
        var currentCoolingItem = findCurrentCoolingItem(cart, coolingVariantIds);

        if (currentCoolingItem && selectOptionForVariantId(box, String(currentCoolingItem.variant_id))) {
          setReplacementConfirmation(box, String(currentCoolingItem.variant_id));
        }

        updateOptOutState(box);
        updateSelectedOptionState(box);
      })
      .fail(function () {
        updateOptOutState(box);
        updateSelectedOptionState(box);
      });
  }

  function syncCoolingOption(box, selectedVariantId) {
    selectedVariantId = selectedVariantId || getSelectedVariantId(box);
    var coolingVariantIds = getCoolingVariantIds(box);

    if (!coolingVariantIds.length) return getCart();

    return getCart().then(function (cart) {
      var updates = {};
      var selectedAlreadyInCart = false;

      $.each(cart.items, function (_, item) {
        var variantId = String(item.variant_id);
        if ($.inArray(variantId, coolingVariantIds) === -1) return;

        if (selectedVariantId && variantId === String(selectedVariantId)) {
          selectedAlreadyInCart = true;
          if (item.quantity > 1) updates[item.key] = 1;
        } else {
          updates[item.key] = 0;
        }
      });

      var updateRequest = Object.keys(updates).length ? updateCart(updates) : $.Deferred().resolve(cart).promise();

      return updateRequest.then(function () {
        if (!selectedVariantId || selectedAlreadyInCart) return getCart();
        return addCoolingItem(selectedVariantId).then(getCart);
      });
    });
  }

  $(document).on('change', '[data-meltable-option]', function () {
    var box = this.closest('[data-meltable]');
    var selectedVariantId = getSelectedVariantId(box);

    showError(box, '');
    updateOptOutState(box);
    updateSelectedOptionState(box);
    clearReplacementConfirmation(box);
    clearOptOutConfirmation(box);

    prepareSelection(box, selectedVariantId)
      .fail(function (result) {
        var conflictVariantId = result && result.conflict ? String(result.conflict.variant_id) : '';
        var conflictOption = getOptionForVariantId(box, conflictVariantId);
        var previousOptionValue = box.getAttribute('data-meltable-previous-option-value');
        var previousOption = previousOptionValue ? box.querySelector('[data-meltable-option][value="' + previousOptionValue + '"]') : null;

        if (conflictOption) {
          conflictOption.checked = true;
        } else if (previousOption) {
          previousOption.checked = true;
        }

        updateOptOutState(box);
        updateSelectedOptionState(box);
        showError(box, '');
      });
  });

  $(document).on('pointerdown', '.meltable__option', function () {
    storePreviousSelection(this.closest('[data-meltable]'));
  });

  $(document).on('focusin keydown', '[data-meltable-option]', function () {
    var box = this.closest('[data-meltable]');
    storePreviousSelection(box);
  });

  $(function () {
    $('[data-meltable]').each(function () {
      updateSelectedOptionState(this);
      initializeFromCart(this);
    });
  });

  window.Meltable = {
    getBox: getMeltableBox,
    getSelectedVariantId: getSelectedVariantId,
    prepareSelection: prepareSelection,
    confirmCoolingReplacement: confirmCoolingReplacement,
    validate: validateSelection,
    syncCoolingOption: syncCoolingOption,
    showError: showError
  };
})();
